"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

require("./DataWidget.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class DataWidget extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getSize", () => {
      const widgetSize = this.props.widgetSize;

      if (!widgetSize) {
        return {};
      }

      const grid = widgetSize.split(":");
      return {
        cols: parseInt(grid[0]),
        rows: parseInt(grid[1])
      };
    });

    _defineProperty(this, "getChart", () => {
      const _this$props = this.props,
            chart = _this$props.chart,
            theme = _this$props.theme,
            widgetSize = _this$props.widgetSize;

      const _this$getSize = this.getSize(),
            cols = _this$getSize.cols,
            rows = _this$getSize.rows;

      let padding, margin, offset;
      margin = {
        top: 60,
        right: 0,
        bottom: 0,
        left: 0
      };

      if (cols && cols >= 2) {
        margin.top = 75;
      } else {}

      offset = {
        top: margin.top * -1,
        right: 0,
        bottom: 0,
        left: 0
      };
      return _extends({}, chart, {
        margin: margin,
        offset: offset,
        theme: theme
      });
    });

    _defineProperty(this, "renderChart", () => {
      const chart = this.getChart();

      if (chart) {
        return _react.default.createElement(_.Chart, chart);
      }
    });
  }

  render() {
    const _this$props2 = this.props,
          loading = _this$props2.loading,
          chart = _this$props2.chart,
          title = _this$props2.title,
          titleUrl = _this$props2.titleUrl,
          description = _this$props2.description;

    if (loading) {
      return _react.default.createElement(_.Widget, this.props, _react.default.createElement(_.WidgetLoading, {
        title: title,
        description: description
      }));
    }

    return _react.default.createElement(_.Widget, this.props, _react.default.createElement(_.WidgetHeader, null, _react.default.createElement(_.WidgetTitle, {
      title: title,
      url: titleUrl
    }), _react.default.createElement(_.WidgetDescription, {
      description: description
    })), _react.default.createElement(_.WidgetBody, null, this.renderChart()));
  }

}

_defineProperty(DataWidget, "defaultProps", {
  expanded: true,
  widgetType: "data",
  widgetSize: "1:1",
  chart: {
    type: undefined,
    metric: undefined,
    range: undefined,
    compare: undefined,
    stacked: undefined
  }
});

var _default = DataWidget;
exports.default = _default;
module.exports = exports.default;